import { ActionBar, Input } from '@viapeople/components'
import { useForm } from 'react-hook-form'
import type { RoleFormInput } from '../types'

interface RoleFormProps {
	initialValues: RoleFormInput
	onSubmit: (data: RoleFormInput) => void | Promise<void>
	onCancel?: () => void
	isSubmitting?: boolean
	submitButtonText?: string
	cancelButtonText?: string
	showButtons?: boolean
}

export function RoleForm({
	initialValues,
	onSubmit,
	onCancel,
	isSubmitting = false,
	submitButtonText = 'Save',
	cancelButtonText = 'Cancel',
	showButtons = true,
}: RoleFormProps) {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<RoleFormInput>({
		defaultValues: initialValues,
		mode: 'onChange',
	})

	const handleCancel = () => {
		if (onCancel) onCancel()
	}

	const formId = initialValues.name ? 'editRoleForm' : 'addRoleForm'

	return (
		<form id={formId} className='space-y-6' onSubmit={handleSubmit(onSubmit)}>
			<div className='gap-4 flex flex-col'>
				<Input
					label='Role name'
					placeholder='Enter role name'
					{...register('name', { required: 'Role name is required' })}
					defaultValue={initialValues.name}
					hint={errors.name?.message}
					variant={errors.name ? 'error' : 'default'}
					disabled={isSubmitting}
				/>
				<Input
					label='Enter role display name'
					placeholder='Role display name'
					{...register('displayName', { required: 'Display name is required' })}
					defaultValue={initialValues.displayName}
					hint={errors.displayName?.message}
					variant={errors.displayName ? 'error' : 'default'}
					disabled={isSubmitting}
				/>
				<Input
					label='Role description'
					placeholder='Enter role description'
					{...register('description', { required: 'Description is required' })}
					defaultValue={initialValues.description}
					hint={errors.description?.message}
					variant={errors.description ? 'error' : 'default'}
					disabled={isSubmitting}
				/>
			</div>
			{showButtons && (
				<ActionBar
					rightActions={[
						{
							variant: 'secondary',
							label: cancelButtonText,
							onClick: handleCancel,
						},
						{
							variant: 'primary',
							label: submitButtonText,
							onClick: () => {
								const form = document.getElementById(formId) as HTMLFormElement
								form?.dispatchEvent(new Event('submit', { bubbles: true }))
							},
							disabled: isSubmitting,
						},
					]}
				/>
			)}
		</form>
	)
}
